import { render, staticRenderFns } from "./_ticketListReviewAuditAffiliate.vue?vue&type=template&id=c6f10054&lang=pug"
import script from "./_ticketListReviewAuditAffiliate.vue?vue&type=script&lang=js"
export * from "./_ticketListReviewAuditAffiliate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports